import { m } from "../../paraglide/messages.js";

// Facts of the platform, each one from CLAUDE.md and its ADRs: no figure the repo does not hold (ADR-286).
const facts = [
  { title: m.hood_edge_title, body: m.hood_edge_body },
  { title: m.hood_db_title, body: m.hood_db_body },
  { title: m.hood_live_title, body: m.hood_live_body },
  { title: m.hood_phone_title, body: m.hood_phone_body },
];

export function UnderTheHood() {
  return (
    <section className="hood" aria-labelledby="hood-title">
      <h2 id="hood-title" className="kicker">
        {m.hood_title()}
      </h2>
      <ul className="hood-facts">
        {facts.map((fact) => (
          <li key={fact.title()} className="hood-fact">
            <h3>{fact.title()}</h3>
            <p className="hood-fact-body">{fact.body()}</p>
          </li>
        ))}
      </ul>
    </section>
  );
}
